export function getDimensionNumber( dimension: string | number| undefined, parent?: HTMLElement ): number {
    if( typeof dimension === "undefined") {
        return 0
    }
    if( typeof dimension === "number") {
        return dimension
    }
    if(  typeof dimension === "string") {
        if( dimension.indexOf("px") > 0 ) {
            return parseInt(dimension)
        }
        if( dimension.indexOf("vh") > 0 ) {
            const h = parseInt(dimension)
            return window.innerHeight * h 
        }
        if( dimension.indexOf("vw") > 0 ) {
            const h = parseInt(dimension)
            return window.innerWidth * h 
        }
        return 330
    }
    return 330
}